const androidFBFlow = async () => {
  const response = window.Android.initfacebookLogin();
}

export default androidFBFlow;